// AI-CONTEXT: See docs/features/platform-stats-trend-sparklines.md

/**
 * Rebases a monthly series on its first month: that month becomes 0% and every
 * later point is its change against that baseline, in percentage points. The
 * KPI tile shows the last point — the growth since the series started.
 *
 * A baseline of 0 yields no series: growth from nothing has no percentage, and
 * a fabricated figure would read as real. Below two points there is nothing to
 * compare, so nothing is returned and the tile stays bare.
 *
 * @param {Array<{ month: string, value: number }>} series - ascending monthly series
 * @returns {Array<{ month: string, value: number }>} percentage-change series
 */
const toPercentSeries = (series) => {
    if (!Array.isArray(series) || series.length < 2) return []

    const baseline = series[0].value
    if (!Number.isFinite(baseline) || baseline === 0) return []

    return series.map((point) => ({
        month: point.month,
        value: ((point.value - baseline) / baseline) * 100,
    }))
}

export default toPercentSeries
